function formatDeadline(deadline) {
  if (!deadline) return null;

  const parsed = new Date(deadline);
  if (Number.isNaN(parsed.getTime())) return null;

  return parsed.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "America/Sao_Paulo",
  });
}

export default function RsvpClosedState({ theme, deadline }) {
  const formattedDeadline = formatDeadline(deadline);
  const titleWeight = theme?.closedTitleWeight === "normal" ? 400 : 700;

  return (
    <div style={{
      textAlign: "center",
      padding: "32px 16px",
      background: theme?.closedBg ?? theme?.sectionBg ?? "rgba(0,0,0,0.04)",
      borderRadius: 16,
      border: `1px solid ${theme?.closedBorder ?? "rgba(0,0,0,0.08)"}`,
    }}>
      <div style={{ fontSize: 40, marginBottom: 12 }}>⏰</div>
      <p style={{
        fontSize: 18,
        fontWeight: titleWeight,
        color: theme?.closedTitleColor ?? theme?.titulo?.color ?? "#333",
        marginBottom: 6,
      }}>
        O prazo para confirmação encerrou
      </p>
      <p style={{ fontSize: 14, color: theme?.closedTextColor ?? theme?.mutedTextColor ?? "#888" }}>
        {formattedDeadline
          ? `As confirmações de presença foram encerradas em ${formattedDeadline}.`
          : "As confirmações de presença foram encerradas."}
      </p>
    </div>
  );
}
